let $elements = $('.js-input-file');
let $fileNameElements = $('.js-filename');

$elements.change(function(){
	
	let $el = $(this);
	let $elFileName = $el.parent().find('.js-filename');
	
	if(!$el.data('default-text')) {
		$el.data('default-text', $elFileName.text());
	}
	
	let fileName = '';
	
	
	if(this.files.length > 0) {
		fileName = this.files[0].name;
	}
	else {
		fileName = $el.data('default-text');
	}
	
	$elFileName.html(fileName);
	
});